import FieldComponentFactory from "./FieldComponent.js"
import FieldValidationFactory from "./FieldValidation.js"
import { useState, useEffect, useRef } from 'react'

/*
*
* se encarga de crear un field que contiene un objeto de filed validation y field component para checar valides y tener el html.
* 
*/

function useDidUpdateEffect(fn, inputs) {
    const didMountRef = useRef(false);
    // console.log(inputs, fn);
    useEffect(() => {
        if (didMountRef.current)
            fn();
        else
            didMountRef.current = true;
    }, inputs)
}

const FieldFactory = (props, checkForm, form) => {
    let type = props.type;
    let name = props.name;

    const [value, setValue] = useState("");

    let linkdFields = [];
    let linkdFieldsReady = [];

    let fieldValidation = FieldValidationFactory(props, checkForm, linkdFieldsReady, form);

    let fieldComponent = FieldComponentFactory(props, setValue, form);

    let valueListeners = []

    if (props.controlFieldListeners) {
        props.controlFieldListeners.map(cfListener => {
            let fieldToListen = form().getField(cfListener.fieldName);
            if (!fieldToListen) return;
            let controlListenerFn = null
            switch (cfListener.type) {
                case 'cross-reference-trigger':
                    controlListenerFn = (valueInput) => {
                        if (!valueInput || valueInput.warning) {  return }
                        let valueGotten = '';
                        cfListener.triggers.map(trigger => {
                            if (trigger.value == valueInput) {
                                if (trigger.groupField) {
                                    let valueGroup = {}
                                    trigger.fields.map(fieldName => {
                                        if (valueGroup) {
                                            valueGroup[fieldName] = form().getField(fieldName).getValue();
                                            if (!valueGroup[fieldName]) valueGroup = ''
                                        }
                                    })
                                    valueGotten = valueGroup
                                } else {
                                    valueGotten = form().getField(trigger.field).getValue()
                                }
                            }
                        })
                        setValue(valueGotten);
                    }
                    break;
                case 'get-value':
                    controlListenerFn = (valueInput) => {
                        if (!valueInput) { return }
                        if (valueInput.warning) { return }
                        if (cfListener.triggerField) {
                            if (form().getField(cfListener.triggerField.fieldName).getValue() != cfListener.triggerField.value) return;
                        }
                        let valueGotten = '';
                        if (cfListener.groupField) {
                            let valueGroup = {}
                            valueGroup[cfListener.fieldName] = valueInput
                            cfListener.fields.map(fieldName => {
                                if (valueGroup) {
                                    valueGroup[fieldName] = form().getField(fieldName).getValue();
                                    if (!valueGroup[fieldName]) valueGroup = '';
                                }
                            })
                            valueGotten = valueGroup
                        } else {
                            valueGotten = valueInput
                        }
                        setValue(valueGotten)
                    }
                    break
                default:
                    break;
            }
            fieldToListen.addValueListener(controlListenerFn)
        })
    }

    let size = {
        size: value.length,
        links: linkdFieldsReady
    }
    useDidUpdateEffect(() => {
        // console.log(value)
        // let size = {
        //     size: value.length,
        //     links: linkdFieldsReady
        // }
        checkValidity()
        valueListeners.map(fn => {
            fn(value);
        })
    }, [value])

    let checkValidity = (formCheck = false) => {
        linkdFieldsReady.forEach(field => {
            size.size += field.getValue().length
        });

        fieldComponent.changeWarning(fieldValidation.getWarning(value, size));
        linkdFields.forEach(field => {
            field.changeValue(value)
        })

        if (props.type == "abstract-group") {
            if (value) {
                form().getField(props.warningField).changeWarning("")
            }
        }
        if (formCheck) {
            if (props.type == "abstract-group" && !value) {
                form().getField(props.warningField).changeWarning("Complete el campo")
            }
        }
    }

    // useEffect(()=>{

    // },[value])

    return {
        clear() {
            fieldComponent.clear();
        },
        getEndpointResponse() {
            return fieldComponent.getEndpointResponse();
        },
        getValue() {
            return value;
        },
        getLabel() {
            return props.label
        },
        addValueListener(fn) {
            valueListeners.push(fn)
        },
        getName() {
            return name;
        },
        checkField(formCheck = false) {
            checkValidity(formCheck)
        },
        setReady(state, warning) {
            // console.log("miau")
            fieldValidation.setReady(state);
            fieldComponent.changeWarning(warning, true);
        },
        changeWarning(warning) {
            fieldComponent.changeWarning(warning);
        },
        changeValue(value) {
            setValue(value);
            fieldComponent.changeValue(value);
        },
        linkFields(field) {
            linkdFields.push(field)
        },
        linkSize(field) {
            linkdFieldsReady.push(field)
        },
        isReady() {
            return fieldValidation.isReady();
        },
        setOptions(opts) {
            fieldComponent.setOptions(opts);
        },
        updateReqFields(set) {
            fieldComponent.updateReqFields(set);
        },
        getHTML() {
            return fieldComponent.getHTML();
        }
    }

}

export default FieldFactory